import { render, staticRenderFns } from "./AubeCoinAutomaticRemittance.vue?vue&type=template&id=44a1c2bf&scoped=true&"
import script from "./AubeCoinAutomaticRemittance.vue?vue&type=script&lang=js&"
export * from "./AubeCoinAutomaticRemittance.vue?vue&type=script&lang=js&"
import style0 from "./AubeCoinAutomaticRemittance.vue?vue&type=style&index=0&id=44a1c2bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a1c2bf",
  null
  
)

export default component.exports